// The reducer that holds graph data information.
// @flow
import { ACTIONS } from '../actions';
import type { GraphState } from '../constants';

type Action = {
    graphData: GraphState,
    type: string
};

const emptyGraphData = {
    params: {},
    xValues: [],
    yValues: []
};

export const graphData = (
    state: GraphState = null,
    action: Action = {
        type: '',
        graphData: emptyGraphData
    }
): GraphState => {
    switch (action.type) {
        case ACTIONS.INITIALIZE:
            if (action.graphData) {
                return { ...action.graphData };
            }
            return emptyGraphData;
        default:
            return state;
    }
};
